import { RouteItem } from '@eastcoal/router/types/route'

import { PLATFORM_FEE_PAGE_UUID } from './constants/uuid'

export const platformFeeRoute: RouteItem = {
  title: '平台收费',
  uuid: PLATFORM_FEE_PAGE_UUID,
  path: '/platformFee',
  Component: () => import('./index')
}
